import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface IIndustryTransitionModalState {
    readonly isOpen: boolean;
    readonly hasUsedEnrollRetry: boolean;
    /** Cleared only on {@link reset}, so a click hides the link for the rest of the SI session. */
    readonly hasSentContactEmail: boolean;
    readonly open: () => void;
    /**
     * Closing while an uncancellable enroll is in flight is refused by the hook that owns the write, not
     * here — the store has no view of the mutation, so gating on server state belongs with the caller.
     */
    readonly close: () => void;
    readonly markEnrollRetryUsed: () => void;
    readonly markContactEmailSent: () => void;
    readonly reset: () => void;
}

const INITIAL_STATE = {
    isOpen: false,
    hasUsedEnrollRetry: false,
    hasSentContactEmail: false,
} as const;

/**
 * Transport for the host that owns the modal, which mounts the subtree only while `isOpen`. Keeping it
 * out of the banners matters: they hide themselves the moment enrolling succeeds, which would unmount
 * the success screen the admin is reading.
 */
export const useIndustryTransitionModalStore = create<IIndustryTransitionModalState>()(
    devtools(
        (set) => ({
            ...INITIAL_STATE,
            open: () => set({ isOpen: true, hasUsedEnrollRetry: false }, false, "open"),
            close: () => set({ isOpen: false }, false, "close"),
            markEnrollRetryUsed: () => set({ hasUsedEnrollRetry: true }, false, "markEnrollRetryUsed"),
            markContactEmailSent: () => set({ hasSentContactEmail: true }, false, "markContactEmailSent"),
            reset: () => set(INITIAL_STATE, false, "reset"),
        }),
        { name: "IndustryTransitionModalStore" },
    ),
);
